import { render, staticRenderFns } from "./CveCarousel.vue?vue&type=template&id=071dbe2f"
import script from "./CveCarousel.vue?vue&type=script&lang=js"
export * from "./CveCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports